"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tableCell = void 0;

var _stylitas = require("@creditas/stylitas");

const tableCell = ({
  textAlign,
  verticalAlign
}) => (0, _stylitas.css)`
  padding: 10px;
  text-align: ${textAlign};
  vertical-align: ${verticalAlign};
`;

exports.tableCell = tableCell;